import React, { useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useJiraServiceManagementProjectNavigation as useJiraServiceManagementProjectNavigationBase } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { nav3QueueGroupsStateResource } from '@atlassian/jira-router-resources-service-desk-queues/src/services/nav3-queue-groups-state-resource/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import useServiceProjectFeatures from '@atlassian/jira-servicedesk-features-store/src/index.tsx';
import { NavigationCategoryContainer } from '@atlassian/jira-servicedesk-queues-categorized-store/src/controllers/navigation-category/index.tsx';
import { usePracticeList } from '@atlassian/jira-servicedesk-queues-categorized-store/src/main.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { MenuPractices } from './menu-practices/index.tsx';
import { Menu } from './menu/index.tsx';

const useJiraServiceManagementProjectNavigation = withThrowOnError(
	useJiraServiceManagementProjectNavigationBase,
);
const useThrowProject = withThrowOnError(useProject);

export const SidebarServicedesk = (): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const route = useCurrentRoute();
	const { loading: serviceProjectFeatureLoading } = useServiceProjectFeatures();
	const accountId = useAccountId();
	const [practiceList, loadingPractice] = usePracticeList();
	const hasPractices = practiceList && practiceList.length > 1;
	const { data: project } = useThrowProject();

	let queueGroupsData;
	if (fg('fe-move-nav3-selected-queue-fu')) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		queueGroupsData = useResource(nav3QueueGroupsStateResource);
	}

	useEffect(() => {
		if (!accountId && fg('fe-move-nav3-selected-queue-fu')) {
			fireTrackAnalytics(createAnalyticsEvent({}), 'gettingAccountIdFromTenantContext failed');
		}
	}, [accountId, createAnalyticsEvent]);

	const { data, loading } = useJiraServiceManagementProjectNavigation();
	if (
		loading ||
		loadingPractice ||
		data == null ||
		// route.group === 'servicedesk' means it's on project navigation, not under settings.
		// Data come back from useServiceProjectFeatures only controls items under "Operations" section on project navigation
		(serviceProjectFeatureLoading && route.group === 'servicedesk')
	) {
		return <Skeleton isFull />;
	}

	return (
		<>
			<SidebarRenderStart />
			<NavigationCategoryContainer
				projectKey={project ? project.key : ''}
				accountId={accountId}
				initialState={queueGroupsData?.data}
				scope={project ? project.key : ''}
			>
				{hasPractices === true ? <MenuPractices /> : <Menu />}
			</NavigationCategoryContainer>
			{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.JSM} />}
		</>
	);
};

export default SidebarServicedesk;
